<div style="height: 40rem; max-height: 80vh; overflow-y:auto;">
  <sb-clipboard-list-input (entriesChanged)="onEntriesChanged($event)"></sb-clipboard-list-input>

  <sb-button classes="btn-primary mt-3" [disabled]="entries.length === 0" (click)="close()"
  >{{'lang.globals.save' | translate}}</sb-button>
</div>

